// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bGeneralMessagePreview {
    min-height: 500px;
    padding-top: 15px;
}

.eGeneralMessagePreviewPush {
    display: flex;
    align-items: center;

    width: 100%;
    height: 100%;
    max-width: 200px;
    min-height: 440px;
    margin: auto;

    background: url("/dist/images/iphone_white.png") no-repeat center;
    background-size: contain;
}

.eGeneralMessagePreviewPushLogo {
    height: auto;
    width: 15px;
    margin-bottom: 4px;
    margin-right: 4px;
}

.eGeneralMessagePreviewPushMessage {
    width: 100%;
    padding: 8px;
    margin-left: 12%;
    margin-right: 12%;

    background: #ffffff;
    border-radius: 6px;

    color: #333132;
    font-size: 10px;
}

.eGeneralMessagePreviewSms {
    width: 100%;
    height: 100%;
    max-width: 200px;
    min-height: 440px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;

    background: url("/dist/images/iphone_black.png") no-repeat center top;
    background-size: contain;
}

.eGeneralMessagePreviewSmsMessage {
    width: 130px;
    max-width: 70%;
    margin-left: 12%;
    margin-right: 12%;
    padding: 8px;

    background: #ffffff;
    border-radius: 6px;

    color: #333132;
    font-size: 10px;
    line-height: 1.25;
}

.eGeneralMessagePreviewSmsTime {
    width: 100%;
    margin-top: 80px;
    margin-bottom: 4px;
    text-align: center;

    font-size: 9px;
    color: #8c8c8c;
}

.eGeneralMessagePreviewEmailHeader {
    background: #c4df9b;
}

.eGeneralMessagePreviewEmailBody {
    max-width: 100%;
    overflow-wrap: anywhere;
}

.eGeneralMessagePreviewEmailBody img {
    max-width: 100% !important;
    height: auto !important;
    object-fit: contain;
}

.eGeneralMessagePreviewPushHeader {
    background: #bae2f7;
}

.eGeneralMessagePreviewSmsHeader {
    background: #f2ecc4;
}

.gmPreviewSms.gmPreviewSms--device {
    width: min(100%, 330px);
    min-height: 460px;
    margin: 0 auto;
    padding: 10px 10px 12px;
    overflow: hidden;
    border: 7px solid #172033;
    border-radius: 34px;
    background: #f8fafc;
    box-shadow: 0 18px 42px rgba(15, 23, 42, 0.18);
    color: #0f172a;
}

.gmPreviewSms--device .gmPreviewSms__statusBar {
    display: flex;
    min-height: 24px;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    font-size: 10px;
    font-weight: 750;
}

.gmPreviewSms--device .gmPreviewSms__contact {
    display: grid;
    grid-template-columns: 28px 38px minmax(0, 1fr) 20px;
    align-items: center;
    gap: 5px;
    padding: 9px 4px 11px;
    border-bottom: 1px solid #e2e8f0;
}

.gmPreviewSms--device .gmPreviewSms__back,
.gmPreviewSms--device .gmPreviewSms__contactChevron {
    color: #227ebd;
    font-size: 27px;
    font-weight: 350;
    line-height: 1;
}

.gmPreviewSms--device .gmPreviewSms__contactAvatar {
    display: inline-flex;
    width: 36px;
    height: 36px;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: linear-gradient(145deg, #227ebd, #155d8c);
    color: #fff;
    font-size: 15px;
    font-weight: 800;
}

.gmPreviewSms--device .gmPreviewSms__sender {
    min-width: 0;
    overflow: hidden;
    margin: 0;
    color: #0f172a;
    font-size: 12px;
    font-weight: 750;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.gmPreviewSms--device .gmPreviewSms__conversation {
    min-height: 318px;
    padding: 14px 5px;
}

.gmPreviewSms--device .gmPreviewSms__day {
    margin-bottom: 14px;
    color: #94a3b8;
    font-size: 10px;
    font-weight: 650;
    text-align: center;
}

.gmPreviewSms--device .gmPreviewSms__bubble {
    width: fit-content;
    max-width: 88%;
    padding: 10px 12px;
    overflow-wrap: anywhere;
    border-radius: 15px 15px 15px 5px;
    background: #e5e7eb;
    color: #1f2937;
    font-size: 13px;
    line-height: 1.45;
    white-space: pre-wrap;
}

.gmPreviewSms--device .gmPreviewSms__composer {
    display: grid;
    grid-template-columns: 26px minmax(0, 1fr) 26px;
    align-items: center;
    gap: 7px;
    color: #64748b;
    font-size: 18px;
}

.gmPreviewSms--device .gmPreviewSms__composerField {
    display: flex;
    min-height: 32px;
    align-items: center;
    padding: 0 11px;
    border: 1px solid #cbd5e1;
    border-radius: 999px;
    background: #fff;
    color: #94a3b8;
    font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./src/components/GeneralMessagePreview/GeneralMessagePreview.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;;IAEZ,iEAAiE;IACjE,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;;IAEjB,mBAAmB;IACnB,kBAAkB;;IAElB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;;IAEhB,qEAAqE;IACrE,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;;IAEZ,mBAAmB;IACnB,kBAAkB;;IAElB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;;IAElB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,8CAA8C;IAC9C,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,mBAAmB;IACnB,QAAQ;IACR,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qDAAqD;IACrD,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,iCAAiC;IACjC,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,+CAA+C;IAC/C,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB","sourcesContent":[".bGeneralMessagePreview {\n    min-height: 500px;\n    padding-top: 15px;\n}\n\n.eGeneralMessagePreviewPush {\n    display: flex;\n    align-items: center;\n\n    width: 100%;\n    height: 100%;\n    max-width: 200px;\n    min-height: 440px;\n    margin: auto;\n\n    background: url(\"/dist/images/iphone_white.png\") no-repeat center;\n    background-size: contain;\n}\n\n.eGeneralMessagePreviewPushLogo {\n    height: auto;\n    width: 15px;\n    margin-bottom: 4px;\n    margin-right: 4px;\n}\n\n.eGeneralMessagePreviewPushMessage {\n    width: 100%;\n    padding: 8px;\n    margin-left: 12%;\n    margin-right: 12%;\n\n    background: #ffffff;\n    border-radius: 6px;\n\n    color: #333132;\n    font-size: 10px;\n}\n\n.eGeneralMessagePreviewSms {\n    width: 100%;\n    height: 100%;\n    max-width: 200px;\n    min-height: 440px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 20px;\n\n    background: url(\"/dist/images/iphone_black.png\") no-repeat center top;\n    background-size: contain;\n}\n\n.eGeneralMessagePreviewSmsMessage {\n    width: 130px;\n    max-width: 70%;\n    margin-left: 12%;\n    margin-right: 12%;\n    padding: 8px;\n\n    background: #ffffff;\n    border-radius: 6px;\n\n    color: #333132;\n    font-size: 10px;\n    line-height: 1.25;\n}\n\n.eGeneralMessagePreviewSmsTime {\n    width: 100%;\n    margin-top: 80px;\n    margin-bottom: 4px;\n    text-align: center;\n\n    font-size: 9px;\n    color: #8c8c8c;\n}\n\n.eGeneralMessagePreviewEmailHeader {\n    background: #c4df9b;\n}\n\n.eGeneralMessagePreviewEmailBody {\n    max-width: 100%;\n    overflow-wrap: anywhere;\n}\n\n.eGeneralMessagePreviewEmailBody img {\n    max-width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n}\n\n.eGeneralMessagePreviewPushHeader {\n    background: #bae2f7;\n}\n\n.eGeneralMessagePreviewSmsHeader {\n    background: #f2ecc4;\n}\n\n.gmPreviewSms.gmPreviewSms--device {\n    width: min(100%, 330px);\n    min-height: 460px;\n    margin: 0 auto;\n    padding: 10px 10px 12px;\n    overflow: hidden;\n    border: 7px solid #172033;\n    border-radius: 34px;\n    background: #f8fafc;\n    box-shadow: 0 18px 42px rgba(15, 23, 42, 0.18);\n    color: #0f172a;\n}\n\n.gmPreviewSms--device .gmPreviewSms__statusBar {\n    display: flex;\n    min-height: 24px;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 10px;\n    font-size: 10px;\n    font-weight: 750;\n}\n\n.gmPreviewSms--device .gmPreviewSms__contact {\n    display: grid;\n    grid-template-columns: 28px 38px minmax(0, 1fr) 20px;\n    align-items: center;\n    gap: 5px;\n    padding: 9px 4px 11px;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.gmPreviewSms--device .gmPreviewSms__back,\n.gmPreviewSms--device .gmPreviewSms__contactChevron {\n    color: #227ebd;\n    font-size: 27px;\n    font-weight: 350;\n    line-height: 1;\n}\n\n.gmPreviewSms--device .gmPreviewSms__contactAvatar {\n    display: inline-flex;\n    width: 36px;\n    height: 36px;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    background: linear-gradient(145deg, #227ebd, #155d8c);\n    color: #fff;\n    font-size: 15px;\n    font-weight: 800;\n}\n\n.gmPreviewSms--device .gmPreviewSms__sender {\n    min-width: 0;\n    overflow: hidden;\n    margin: 0;\n    color: #0f172a;\n    font-size: 12px;\n    font-weight: 750;\n    text-align: left;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.gmPreviewSms--device .gmPreviewSms__conversation {\n    min-height: 318px;\n    padding: 14px 5px;\n}\n\n.gmPreviewSms--device .gmPreviewSms__day {\n    margin-bottom: 14px;\n    color: #94a3b8;\n    font-size: 10px;\n    font-weight: 650;\n    text-align: center;\n}\n\n.gmPreviewSms--device .gmPreviewSms__bubble {\n    width: fit-content;\n    max-width: 88%;\n    padding: 10px 12px;\n    overflow-wrap: anywhere;\n    border-radius: 15px 15px 15px 5px;\n    background: #e5e7eb;\n    color: #1f2937;\n    font-size: 13px;\n    line-height: 1.45;\n    white-space: pre-wrap;\n}\n\n.gmPreviewSms--device .gmPreviewSms__composer {\n    display: grid;\n    grid-template-columns: 26px minmax(0, 1fr) 26px;\n    align-items: center;\n    gap: 7px;\n    color: #64748b;\n    font-size: 18px;\n}\n\n.gmPreviewSms--device .gmPreviewSms__composerField {\n    display: flex;\n    min-height: 32px;\n    align-items: center;\n    padding: 0 11px;\n    border: 1px solid #cbd5e1;\n    border-radius: 999px;\n    background: #fff;\n    color: #94a3b8;\n    font-size: 11px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
